export default __webpack_public_path__ + "static/media/NC_256x256.e9e77d71.png";